import {useMutation, UseMutationOptions} from '@tanstack/react-query';
import {AxiosResponse} from 'axios';
import {API_HOST} from 'config';
import {QueryKeyEnum} from 'types';

import {api} from '../../setup';

type SMSData = {phoneNumber: string; token: string | null; type?: 'sms' | 'whatsapp'};
type SMSResponse = AxiosResponse<any>;

export const useCodeBySMS = (options?: UseMutationOptions<SMSResponse, Error, SMSData>) => {
  return useMutation<SMSResponse, Error, SMSData>({
    mutationKey: [QueryKeyEnum.TOKEN],
    mutationFn: async (data) =>
      api.post(
        '/sms/send-sms',
        {
          phone_number: data.phoneNumber,
          app: 'website',
          recaptcha_token: data.token,
          type: data.type || 'sms',
        },
        {
          baseURL: API_HOST + '/api',
        },
      ),
    ...options,
  });
};

export const useLoginBySMSCode = (data: any, options?: UseMutationOptions) => {
  return useMutation<any>({
    mutationFn: () => api.post('/login', data),
    ...options,
  });
};
